import { render, staticRenderFns } from "./ui-emoji.vue?vue&type=template&id=607f5b36&"
import script from "./ui-emoji.vue?vue&type=script&lang=ts&"
export * from "./ui-emoji.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports